import { FilterPresetEnum } from "@finway-group/shared/lib/models/filter/filterPreset.enum"
import { TablesEnum } from "Shared/store/reducers/tableConfigReducer"
import { applyFilter } from "./filter.utils"

import store from "Shared/store"

export const getCurrentPresets = (filterObject: any) => (filterObject?.presets as FilterPresetEnum[]) ?? []

export const setQuickFilter = (table: TablesEnum, presets: FilterPresetEnum[]) => {
    const filterObject = store.getState().tables[table].data.filter
    applyFilter(table, { ...filterObject, presets }, true)
}
